import {StyleSheet} from 'react-native';
import {getScreenSize, scale} from "../../../../../common/utils";

export default StyleSheet.create({
    label:{
        backgroundColor: "#EBFFF8",
        borderTopLeftRadius: 0,
        borderTopRightRadius: 8,
        borderBottomLeftRadius: 8,
        borderBottomRightRadius: 0,
        paddingHorizontal:6,
        height: 14,
        top:0,
        right:0,
        position: 'absolute'
    },
    labelText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#00B87A",
        height: 14,
    },

    rankField:{
        width: 40,
        alignSelf: 'center'
    },
    rankText:{
        fontSize: 18,
        color: "#333333",
        width: 40,
        height: 40,
        lineHeight: 40,
        textAlign:'center',
        fontFamily: "hotel_rn_num_v1"
    },
    rankImage:{
        width: 40,
        height: 40,
    },
    cheapRankItem:{
        position: 'relative',
        marginHorizontal: 16,
        marginTop: 8,
        paddingLeft: 12,
        paddingRight: 25,
        paddingVertical: 14,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent:'space-between',
        height: 70,
        borderRadius: 8,
        overflow:'hidden'
    },

    cheapRankItemBgColor:{
        position: 'absolute',
        left: 0,
        backgroundColor: '#fff',
        height: '100%',
        width: getScreenSize().width - 145
    },

    cheapRankItemBg:{
        width: 113,
        height: 70,
        position: 'absolute',
        right:0
    },

    cheapInfo:{
        flexDirection: 'row',
    },
    rankBaseInfo:{
        marginLeft: 18
    },
    cheapCityText:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: scale(14),
        color: "#FF6600",
        height: 20,
    },
    cheapDateInfo:{
        flexDirection: 'row'
    },
    cheapBackDate:{
        marginLeft: 5
    },
    cheapDate:{
        flexDirection: 'row',
        marginTop: 4
    },

    cheapDateText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 12,
        color: "#999999",
        height: 17,
    },
    cheapWeekText:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 12,
        color: "#999999",
        height: 17,
        marginLeft:2
    },
    rankPriceField:{
        marginTop: 2
    },
    accuratePriceField:{
        flexDirection: 'row',
        alignItems:'baseline',
        justifyContent: 'flex-end'
    },
    priceDiscount:{
        fontFamily: "PingFangSC-Regular",
        fontSize: 10,
        color: "#999999",
        textAlign: "right",
        height: 14,
    },
    priceColor:{
        color: "#FF6600"
    },
    rankPrefixSize:{
        fontFamily: "PingFangSC-Regular",
        fontWeight: 'bold',
        fontSize: 12,
        color: "#FF6600"
    },
    rankYuanSize:{
        fontFamily: "hotel_rn_num_v1",
        fontSize: 20,
        color: "#FF6600",
        height: 24
    }
});